import { isEmptyElement } from '@ublend-npm/aula-editor-utils';

const isEmptyContent = (editorState) => {
  return editorState.value.every((node) => isEmptyElement(node));
};

export default isEmptyContent;
